import { render } from "./AssignmentMarking.vue?vue&type=template&id=17fd8f54"
import script from "./AssignmentMarking.vue?vue&type=script&lang=js"
export * from "./AssignmentMarking.vue?vue&type=script&lang=js"

import "./AssignmentMarking.vue?vue&type=style&index=0&id=17fd8f54&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__